import axios from 'axios';

// Sử dụng biến môi trường cho URL API
const API_URL = process.env.REACT_APP_API_URL;

// Đặt cấu hình axios
axios.defaults.withCredentials = true;

// Lấy thông tin tuyến và các chặng theo tên tuyến
const getTuyen = (tenTuyen) => {
    return axios.get(`${API_URL}/tuyen/${tenTuyen}`);
};

const updateOrInsertTuyenChang = (tuyen, changs) => {
    return axios.post(`${API_URL}/tuyen-chang`, { ...tuyen, changs });
};

// Lấy tất cả các tên tuyến (distinct)
const getAllTenTuyen = () => {
    return axios.get(`${API_URL}/ten-tuyen`);
};

// Tạo tuyến mới
const createNewTuyen = (tuyen) => {
    return axios.put(`${API_URL}/tuyen`, tuyen);
};

// Lấy tất cả thông tin htdt từ API
const getHTDTData = () => {
    return axios.get(`${API_URL}/htdt`);
};

// Hàm gửi dữ liệu nhập biển kiểm soát
const submitNhapBKS = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/nhap-bks`, formData, {
            headers: { 'Content-Type': 'application/json' }, // Gửi dữ liệu dạng JSON
            withCredentials: true, // Gửi kèm session/cookie
        });
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Error submitting data:', error);
        throw new Error('Không thể lưu dữ liệu nhập biển kiểm soát. ' + error.message);
    }
};

// Hàm tìm thông tin theo biển kiểm soát
const timTheoBKS = async (bienKiemSoat, startDay, endDay) => {
    try {
        const params = {
            bien_kiem_soat: bienKiemSoat,
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/lay_tt_nhap_lieu_theo_bks`, { params });
        return response.data;
    } catch (error) {
        console.error('Lỗi khi tìm theo biển kiểm soát:', error);
        throw new Error('Không thể lấy thông tin theo biển kiểm soát.');
    }
};

// Hàm sửa thông tin theo biển kiểm soát
const suaTheoBKS = async (initialData, updatedData) => {
    try {
        const response = await axios.post(`${API_URL}/sua_tt_theo_bks`, {
            initialData,
            updatedData,
        });

        return response.data;
    } catch (error) {
        console.error('Lỗi khi sửa theo biển kiểm soát:', error);
        throw new Error('Không thể sửa thông tin theo biển kiểm soát.');
    }
};

// Hàm gửi dữ liệu tạo tài khoản
const submitTaoTaiKhoan = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/tao-tai-khoan`, formData, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        });
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Error creating account:', error);
        throw new Error('Không thể tạo tài khoản. ' + error.message);
    }
};

// Hàm gửi dữ liệu tạo tài khoản
const submitTaoChuyenKinhDoanh = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/tao-chuyen-kinh-doanh`, formData, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        });
        return response; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Error creating account:', error);
        throw new Error('Không thể tạo chuyến. ' + error.message);
    }
};

const submitTaoDonKinhDoanh = async (formData) => {
    try {
        console.log("Gửi request với session:", formData);
        const response = await axios.post(`${API_URL}/tao-don-kinh-doanh`, formData, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        });
        return response; // Trả về phản hồi từ server
    } catch (error) {
        console.error('Error submitting don kinh doanh:', error);
        throw new Error('Không thể tạo đơn kinh doanh. ' + error.message);
    }
};

/**
 * Chuyển đổi địa chỉ thành tọa độ sử dụng API Geocode của Goong Map.
 * API Document: https://docs.goong.io/#tag/Place/paths/~1Place~1Geocode/get
 */
const getCoordinatesFromAddress = async (address) => {
    try {
      const url = `https://rsapi.goong.io/geocode?api_key=${process.env.REACT_APP_GOONG_API_KEY}&address=${encodeURIComponent(address)}`;
      const response = await axios.get(url, {
        headers: { Accept: 'application/json' }
      });
      // Giả sử API trả về: { results: [ { geometry: { location: { lat, lng } }, ... } ] }
      if (response.data && response.data.results && response.data.results.length > 0) {
        const firstResult = response.data.results[0];
        const { lat, lng } = firstResult.geometry.location; // Sửa ở đây
        return { lat, lng };
      } else {
        throw new Error("Không tìm thấy tọa độ cho địa chỉ này.");
      }
    } catch (error) {
      console.error("Lỗi khi chuyển đổi địa chỉ thành tọa độ:", error.response ? error.response.data : error.message);
      throw error;
    }
  };
  
  /**
 * Lấy định tuyến từ điểm đi đến điểm đến dựa trên tọa độ.
 * originCoords: { lat, lng }
 * destination: chuỗi tọa độ dạng "lat,lng"
 */
  const getRouting = async (originCoords, destination) => {
    try {
      const apiKey = process.env.REACT_APP_GOONG_API_KEY; // Đảm bảo biến môi trường được cấu hình chính xác
      const originStr = `${originCoords.lat},${originCoords.lng}`;
      const url = `https://rsapi.goong.io/Direction?origin=${originStr}&destination=${encodeURIComponent(destination)}&vehicle=truck&api_key=${apiKey}`;
      
      const response = await axios.get(url);
      if (
        response.data &&
        response.data.routes &&
        response.data.routes.length > 0 &&
        response.data.routes[0].overview_polyline &&
        response.data.routes[0].overview_polyline.points
      ) {
        return {
          success: true,
          data: {
            routePolyline: response.data.routes[0].overview_polyline.points,
          },
        };
      } else {
        return { success: false, message: "Không tìm thấy định tuyến." };
      }
    } catch (error) {
      console.error("Lỗi khi lấy định tuyến:", error.response ? error.response.data : error.message);
      return { success: false, message: error.message };
    }
  };

// Hàm lấy lộ trình nhập theo ngày
const getLoTrinhNhap = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/lay_lo_trinh_nhap`, { params });
        return response.data;  // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Lỗi khi lấy lộ trình nhập:', error);
        throw new Error('Không thể lấy dữ liệu lộ trình nhập.');
    }
};

// Hàm lấy dữ liệu KD theo ngày
const getDuLieuKD = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/du_lieu_chuyen_kd`, { params });
        return response.data;  // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Lỗi khi lấy lộ trình nhập:', error);
        throw new Error('Không thể lấy dữ liệu lộ trình nhập.');
    }
};

// Hàm lấy dữ liệu KD với tìm kiếm và phân trang
const getChuyenKinhDoanh = async (params) => {
    try {
        // Gửi yêu cầu GET đến API với các tham số tìm kiếm và phân trang
        const response = await axios.get(`${API_URL}/chuyen_kinh_doanh`, { params });
        return response.data; // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu KD:', error);
        throw new Error('Không thể lấy dữ liệu chuyến kinh doanh.');
    }
};

// Tải xuống báo cáo Excel
const downloadReport = async (startDay, endDay) => {
    try {
        const response = await axios.get(`${API_URL}/download_report`, {
            params: { start_day: startDay, end_day: endDay },
            responseType: 'blob', // Đảm bảo nhận về file binary
        });

        // Tạo URL cho file tải xuống
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Thong_tin_nhap_lieu_tu_tai_xe_${startDay}_${endDay}.xlsx`);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error('Lỗi khi tải báo cáo:', error);
        throw new Error('Không thể tải báo cáo.');
    }
};

// Hàm để gán thêm thông tin (biển kiểm soát và tài xế) cho một chuyến xe
const ganThemThongTin = async (maChuyen, formData) => {
    try {
        const response = await axios.post(`${API_URL}/gan_them_thong_tin/${maChuyen}`, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, // Gửi dữ liệu dạng form URL-encoded
        });

        return response.data; // Trả về dữ liệu từ server (thành công hoặc lỗi)
    } catch (error) {
        console.error(`Error assigning info to trip ${maChuyen}:`, error);
        throw new Error('Không thể gán thêm thông tin cho chuyến xe.');
    }
};

// Hàm hủy gán chuyến kinh doanh
const huyGanChuyenKinhDoanh = async (maChuyen) => {
    try {
        const response = await axios.post(`${API_URL}/huy_gan_chuyen_kinh_doanh/${maChuyen}`, {}, {
            withCredentials: true,  // Gửi kèm session/cookie nếu cần
        });

        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error(`Lỗi khi hủy gán chuyến ${maChuyen}:`, error);
        throw new Error('Không thể hủy gán thông tin cho chuyến xe.');
    }
};

// Hàm hủy chuyến kinh doanh theo ID
const huyChuyenKinhDoanh = async (id) => {
    try {
        const response = await axios.post(`${API_URL}/huy_chuyen_kinh_doanh/${id}`, {}, {
            withCredentials: true,  // Gửi kèm session/cookie nếu cần
        });

        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error(`Lỗi khi hủy chuyến ${id}:`, error);
        throw new Error('Không thể hủy chuyến kinh doanh.');
    }
};

// Hàm tổng hợp dữ liệu doanh thu kinh doanh
const tongHopDoanhThuKinhDoanh = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/export-excel/tong_hop_doanh_thu_kinh_doanh`, { params });
        return response.data;  // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Lỗi khi tổng hợp doanh thu kinh doanh:', error);
        throw new Error('Không thể tổng hợp dữ liệu doanh thu.');
    }
};

// Hàm tải file báo cáo doanh thu kinh doanh
const taiBaoCaoDoanhThuKD = async () => {
    try {
        const response = await axios.get(`${API_URL}/tai_bao_cao_doanh_thu_kd`, {
            responseType: 'blob',  // Đảm bảo nhận về file binary
        });

        // Tạo URL cho file tải xuống
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Bao_cao_doanh_thu_kinh_doanh.xlsx`);  // Tên file khi tải xuống
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error('Lỗi khi tải báo cáo doanh thu kinh doanh:', error);
        throw new Error('Không thể tải báo cáo doanh thu.');
    }
};

// Hàm lấy dữ liệu thô kinh doanh dưới dạng JSON 
const layDuLieuThoKD = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/lay_du_lieu_tho_tong_hop_xe_kd`, {
            params
        });
        return response.data; // Trả về dữ liệu JSON
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu thô KD:', error);
        throw new Error('Không thể lấy dữ liệu thô KD.');
    }
};

const layCacChuyenChuaHoanThanh = async () => {
    try {

        const response = await axios.get(`${API_URL}/lay_cac_chuyen_chua_hoan_thanh`);
        return response.data; // Trả về dữ liệu JSON
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu thô KD:', error);
        throw new Error('Không thể lấy dữ liệu thô KD.');
    }
};

// Hàm lấy dữ liệu chuyến KD đã gán dưới dạng JSON
const layDuLieuChuyenKDDaGan = async (startDay, endDay) => {
    try {
        const params = {
            start_day: startDay,
            end_day: endDay,
        };

        const response = await axios.get(`${API_URL}/export-chuyen-xe`, {
            params
        });
        return response.data; // Trả về dữ liệu JSON
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu chuyến KD đã gán:', error);
        throw new Error('Không thể lấy dữ liệu chuyến KD đã gán.');
    }
};

// Hàm tải thông tin chuyến kinh doanh
const loadThongTinChuyenKD = async () => {
    try {
        // Gọi API để lấy dữ liệu chuyến kinh doanh
        const response = await axios.get(`${API_URL}/thong_tin_chuyen_kd`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi tải thông tin chuyến kinh doanh:', error);
        throw new Error('Không thể tải thông tin chuyến kinh doanh.');
    }
};


// Hàm tải thông tin chuyến kinh doanh
const loadThongTinBangChuyenKD = async () => {
    try {
        // Gọi API để lấy dữ liệu chuyến kinh doanh
        const response = await axios.get(`${API_URL}/load_thong_tin_table_chuyen_kd`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi tải thông tin chuyến kinh doanh:', error);
        throw new Error('Không thể tải thông tin chuyến kinh doanh.');
    }
};

// Hàm gọi đến API load chuyến kinh doanh tài xế hiện tại
const load_chuyen_kd_sai = async () => {
    try {
        const response = await axios.get(`${API_URL}/load_chuyen_kd_sai`);
        return response.data;  // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Error loading chuyen kd tai xe:', error);
        throw new Error('Không thể tải dữ liệu chuyến kinh doanh tài xế. Vui lòng đăng xuất, đăng nhập và thử lại.');
    }
};

const getCameras = async () => {
    try {
        const response = await axios.get(`${API_URL}/camera`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Error fetching cameras:', error);
        throw new Error('Không thể lấy dữ liệu camera.');
    }
};

const themKhachHang = async (maKhachHang) => {
    try {
        // Sử dụng phương thức POST để thêm khách hàng mới
        const response = await axios.post(`${API_URL}/khachhang`, {
            ma_khach_hang: maKhachHang.ma_khach_hang // Truyền mã khách hàng vào body của request
        });

        return response; // Trả về dữ liệu từ server nếu thành công
    } catch (error) {
        console.error('Error adding khachhang:', error);
        throw new Error('Không thể thêm dữ liệu khách hàng mới.');
    }
};

// Hàm lấy dữ liệu chấm công theo tháng và năm
const getAllChamCongData = async (month, year, user) => {
    try {
        // Kiểm tra xem month và year có được cung cấp không
        if (!month || !year) {
            throw new Error("Thiếu month hoặc year trong tham số.");
        }

        // Thực hiện request với month và year
        const response = await axios.get(`${API_URL}/all_cham_cong`, {
            params: {
                month,
                year,
                user,  // user ID nếu cần
            },
        });

        if (response.data.status === "success") {
            return response.data.data;
        } else {
            console.error("Error:", response.data.message);
            throw new Error(response.data.message);
        }
    } catch (error) {
        console.error("Lỗi khi lấy dữ liệu chấm công:", error);
        throw error;
    }
};

// Hàm cập nhật thông tin chuyến kinh doanh
const updateThongTinChuyenKD = async (formData) => {
    try {
        // Thực hiện POST request tới API
        const response = await axios.post(`${API_URL}/update_thong_tin_table_chuyen_kd`, formData, {
            headers: { 'Content-Type': 'application/json' },  // Đảm bảo dữ liệu gửi là JSON
            withCredentials: true,  // Gửi kèm session/cookie nếu cần
        });

        return response.data; // Trả về dữ liệu từ server nếu thành công
    } catch (error) {
        console.error('Lỗi khi cập nhật thông tin chuyến KD:', error);
        throw new Error('Không thể cập nhật thông tin chuyến KD. ' + error.message);
    }
};

const huy_chuyen_kd = async (tripId) => {
    try {
        const response = await axios.post(`${API_URL}/huy_chuyen_kd`, { trip_id: tripId });
        return response.data; // Trả về kết quả từ server
    } catch (error) {
        console.error('Lỗi khi hủy chuyến:', error);
        throw new Error('Không thể hủy chuyến.');
    }
};

const uploadExcelFileKD = async (file) => {
    try {
        // Tạo formData để gửi file
        const formData = new FormData();
        formData.append('file', file);

        // Gửi request POST với formData
        const response = await axios.post(`${API_URL}/upload_excel_kd`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Định dạng tệp
            },
        });

        // Trả về dữ liệu phản hồi từ API
        return response.data;
    } catch (error) {
        console.error('Error uploading Excel file:', error);
        throw new Error(
            error.response?.data?.error || 'Không thể upload file Excel.'
        );
    }
};

const getTongHopChuyen = async () => {
    try {
        const response = await axios.get(`${API_URL}/tong_hop_chuyen`);
        return response.data; // Trả về dữ liệu từ API
    } catch (error) {
        console.error('Error fetching tong hop chuyen data:', error);
        throw new Error('Không thể lấy dữ liệu tổng hợp chuyến.');
    }
};

const getAllTrips = async (page = 1, pageSize = 10) => {
    try {
        const response = await axios.get(`${API_URL}/get_all_trip`, {
            params: { page, pageSize },
        });
        return response.data; // Trả về dữ liệu phân trang
    } catch (error) {
        console.error('Error fetching all trips:', error);
        throw new Error('Không thể lấy thông tin tất cả các chuyến.');
    }
};

// Hàm lấy dữ liệu cơ bản
const getDuLieuCoBan = async () => {
    try {
        const response = await axios.get(`${API_URL}/du_lieu_co_ban`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy dữ liệu cơ bản:', error);
        throw new Error('Không thể lấy dữ liệu cơ bản.');
    }
};

// Hàm lấy tỷ lệ hoạt động
const getTiLeHoatDong = async () => {
    try {
        const response = await axios.get(`${API_URL}/ti_le_hoat_dong`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy tỷ lệ hoạt động:', error);
        throw new Error('Không thể lấy tỷ lệ hoạt động.');
    }
};

// Hàm lấy tỷ lệ lợi nhuận theo xe
const getTiLeLoiNhuanTheoXe = async () => {
    try {
        const response = await axios.get(`${API_URL}/ti_le_loi_nhuan_theo_xe`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy tỷ lệ lợi nhuận theo xe:', error);
        throw new Error('Không thể lấy tỷ lệ lợi nhuận theo xe.');
    }
};

// Hàm tải thông tin chi tiết chuyến theo biển kiểm soát
const loadChiTietChuyenTheoXe = async (bienKiemSoat, currentDay) => {
    try {
        // Kiểm tra tham số đầu vào
        if (!bienKiemSoat || !currentDay) {
            throw new Error('Vui lòng cung cấp biển kiểm soát và ngày hiện tại.');
        }

        // Gọi API để lấy dữ liệu chi tiết chuyến theo biển kiểm soát
        const response = await axios.get(`${API_URL}/chi_tiet_chuyen_theo_xe`, {
            params: {
                bien_kiem_soat: bienKiemSoat,
                current_day: currentDay,
            },
        });

        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi tải thông tin chi tiết chuyến theo xe:', error);
        throw new Error('Không thể tải thông tin chi tiết chuyến theo xe.');
    }
};

const submitSuaChuaBaoDuong = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/bao_duong_sua_chua`, formData, {
            headers: { 'Content-Type': 'application/json' }, // Gửi dữ liệu dạng JSON
        });
        return response.data; // Trả về dữ liệu phản hồi từ server
    } catch (error) {
        console.error('Lỗi khi gửi dữ liệu sửa chữa và bảo dưỡng:', error);
        throw new Error('Không thể lưu dữ liệu sửa chữa và bảo dưỡng. ' + error.message);
    }
};

//Lấy Danh sách Tài Xế
const Lay_DS_Taixe = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_taixe`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy danh sách tài xế:', error);
        throw new Error('Không thể lấy danh sách tài xế.');
    }
}

//Lấy danh sách Trạm bảo dưỡng - sửa chữa
const Lay_DS_Tram = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_tram`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy danh sách tài xế:', error);
        throw new Error('Không thể lấy danh sách tài xế.');
    }
}

// Lấy tất cả thông tin các đơn bảo dưỡng - sửa chữa  cho dashboard
const Lay_DS_Bd_Sc = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_bd_sc`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy danh sách đơn bảo dưỡng - sửa chữa:', error);
        throw new Error('Không thể lấy danh sách đơn bảo dưỡng - sửa chữa.');
    }
}

// Lấy thông tin của các đơn hiện đang ở trạm
const Lay_DS_Bd_Sc_tram = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_bd_sc_tram`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy thông tin của các đơn hiện đang ở trạm:', error);
        throw new Error('Không thể lấy thông tin của các đơn hiện đang ở trạm.');
    }
}

// Lấy thông tin của các đơn bảo dưỡng - sửa chữa đã làm trước đó
const Ls_DS_Bd_Sc = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_ls_bd_sc_tram`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy thông tin của các đơn hiện đang ở trạm:', error);
        throw new Error('Không thể lấy thông tin của các đơn hiện đang ở trạm.');
    }
}

// Lấy thông tin chi phí phụ của đơn bảo dưỡng - sửa chữa nếu có
const Lay_CP_Bd_Sc = async (id) => {
    try {
        // Gọi API để lấy dữ liệu chi phí phụ của đơn bảo dưỡng - sửa chữa
        const response = await axios.get(`${API_URL}/lay_cp_bd_sc`, {
            params: {
                id: id,
            },
        });

        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi chi phí phụ của đơn bảo dưỡng - sửa chữa.', error);
        throw new Error('Không thể tải chi phí phụ của đơn bảo dưỡng - sửa chữa.');
    }
}

// Cập nhật trạng thái đơn bảo dưỡng - sửa chữa
const Update_Bd_Sc = async (id, trang_thai) => {
    try {
        const response = await axios.post(`${API_URL}/update_tt_bd_sc`, {
            id: id,
            trang_thai: trang_thai,
        });
        return response.data; // Trả về dữ liệu phản hồi từ server
    } catch (error) {
        console.error('Lỗi khi cập nhật sửa chữa và bảo dưỡng:', error.response || error);
        throw new Error('Không thể cập nhật sửa chữa và bảo dưỡng. ' + (error.response?.data?.message || error.message));
    }
}

// Cập nhật tài xế mới cho gửi xe hoặc lấy xe của đơn bảo dưỡng - sửa chữa
const UpdateTaiXe = async (id, updateData) => {
    if (!id || !updateData || Object.keys(updateData).length === 0) {
        throw new Error("Thiếu thông tin cần cập nhật.");
    }
    try {
        const response = await axios.post(`${API_URL}/update_tx`, {
            id,
            updateData,
        });
        return response.data; // Trả về dữ liệu phản hồi từ server
    } catch (error) {
        console.error("Lỗi khi cập nhật tài xế:", error.response?.data || error);
        throw new Error(
            "Không thể cập nhật tài xế. " +
            (error.response?.data?.message || error.message)
        );
    }
};

//Gửi đơn vị kinh doanh mới về từ quản lý
const themDonViKinhDoanh = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/them_don_vi_kinh_doanh`, formData, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error('Lỗi khi thêm đơn vị kinh doanh:', error);
        throw new Error('Không thể thêm đơn vị kinh doanh. ' + error.message);
    }
};

const getDonViKinhDoanh = async () => {
    const res = await axios.get(`${API_URL}/don-vi-kinh-doanh`);
    return res.data;
};


//Tạo đơn công nợ mới
const TaoDonCongNo = async (formData) => {
    try {
      const response = await axios.post(`${API_URL}/insert_cong_no`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('Lỗi khi thêm công nợ:', error);
      throw new Error('Không thể thêm công nợ. ' + error.message);
    }
};

// Hàm lấy danh sách công nợ
const getDanhSachCongNo = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_cong_no`);
        return response.data; // Trả về danh sách công nợ từ server
    } catch (error) {
        console.error('Lỗi khi lấy danh sách công nợ:', error);
        throw new Error('Không thể lấy danh sách công nợ.');
    }
};

// Hàm lấy lịch sử thanh toán theo mã hợp đồng
const getLichSuThanhToanCongNo = async (maHd) => {
    try {
        const response = await axios.get(`${API_URL}/lich_su_thanh_toan/${maHd}`);
        return response.data; // Trả về lịch sử thanh toán từ server
    } catch (error) {
        console.error(`Lỗi khi lấy lịch sử thanh toán cho hợp đồng ${maHd}:`, error);
        throw new Error('Không thể lấy lịch sử thanh toán.');
    }
};

// Thanh toán công nợ
const thanhToanCongNo = async (maHd, soTien, ngayThanhToan) => {
    try {
      const response = await axios.post(`${API_URL}/thanh_toan_cong_no`, {
        ma_hd: maHd,
        so_tien: soTien,
        ngay_tt: ngayThanhToan // yyyy-mm-dd
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Không thể thanh toán.");
    }
};

//Cập nhật Thanh toán công nợ
const capNhatLichSuThanhToan = async ({ ma_hd, ngay_tt, so_tien }) => {
    try {
        console.log("Gửi dữ liệu cập nhật thanh toán:", { ma_hd, ngay_tt, so_tien });
        const response = await axios.post(`${API_URL}/cap_nhat_ls_thanh_toan`, {
            ma_hd,
            ngay_tt,
            so_tien
        });
        return response.data;
    } catch (error) {
        console.error('Lỗi khi cập nhật lịch sử thanh toán:', error);
        throw new Error('Không thể cập nhật lịch sử thanh toán.');
    }
};


//Cập nhật đơn công nợ
const CapNhatCongNo = async (maHd, updatedData) => {
    try {
        const response = await axios.post(`${API_URL}/update_cong_no`, {
            ma_hd: maHd,
            ...updatedData
        });
        return response.data; // ✅ response sẽ chứa 'cong_no_ton'
    } catch (error) {
        console.error(`Lỗi khi cập nhật công nợ cho hợp đồng ${maHd}:`, error);
        throw new Error('Không thể cập nhật công nợ.');
    }
};

//Lấy Danh sách nhân viên Sale
const Lay_DS_Sale = async () => {
    try {
        const response = await axios.get(`${API_URL}/ds_nv_sale`);
        return response.data; // Trả về dữ liệu từ server
    } catch (error) {
        console.error('Lỗi khi lấy danh sách sale:', error);
        throw new Error('Không thể lấy danh sách sale.');
    }
}


// Tạo hợp đồng mới
const taoHopDong = async (formData) => {
    try {
      const response = await axios.post(`${API_URL}/tao_hop_dong`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      return response.data;
    } catch (error) {
      console.error('Lỗi khi thêm hợp đồng:', error);
      throw new Error('Không thể thêm hợp đồng. ' + error.message);
    }
};

// Lấy danh sách mã hợp đồng
const getMaHopDong = async () => {
    try {
      const res = await axios.get(`${API_URL}/ds_ma_hd`);
      return res.data;
    } catch (error) {
      console.error("Error in getMaHopDong:", error);
      throw error;
    }
};

// Gắn mã hợp đồng
const ganMaHopDong = async (chuyenId, selectedMaHd) => {
    try {
      const response = await axios.post(`${API_URL}/gan-ma-hop-dong/${chuyenId}`,
        { ma_hd: selectedMaHd },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (error) {
      console.error('Error in ganMaHopDong:', error);
      throw error;
    }
};

// Hàm lấy thông tin xe (từ bảng thong_tin_xe)
const getThongTinXe = async () => {
    try {
        const response = await axios.get(`${API_URL}/thong_tin_xe`);
        return response.data; // Giả sử response.data có cấu trúc { success: true, data: [...] }
    } catch (error) {
        console.error("Lỗi khi lấy thông tin xe:", error);
        throw new Error("Không thể lấy thông tin xe.");
    }
};

// Hàm lấy dữ liệu lịch sử xe (từ bảng du_lieu_xe) theo Serial của xe
const getDuLieuXe = async (serial, date) => {
    try {
        const params = { serial };
        if (date) {
        params.date = date;
        }
        const response = await axios.get(`${API_URL}/du_lieu_xe`, { params });
        return response.data;
    } catch (error) {
        console.error("Lỗi khi lấy dữ liệu lịch sử xe:", error);
        throw new Error("Không thể lấy dữ liệu lịch sử xe.");
    }
};

// Cập nhật ManagerService
const ManagerService = {
    getTuyen,
    updateOrInsertTuyenChang,
    getAllTenTuyen,
    createNewTuyen,
    getHTDTData,
    submitNhapBKS,
    timTheoBKS,
    suaTheoBKS,
    submitTaoTaiKhoan,
    getLoTrinhNhap,
    getDuLieuKD,
    getChuyenKinhDoanh,
    downloadReport,
    submitTaoChuyenKinhDoanh,
    submitTaoDonKinhDoanh,
    ganThemThongTin,
    huyGanChuyenKinhDoanh,
    huyChuyenKinhDoanh,
    tongHopDoanhThuKinhDoanh,  // Thêm hàm tổng hợp doanh thu
    taiBaoCaoDoanhThuKD,  // Thêm hàm tải báo cáo doanh thu
    layDuLieuThoKD,
    layCacChuyenChuaHoanThanh,
    layDuLieuChuyenKDDaGan,
    loadThongTinChuyenKD,
    loadThongTinBangChuyenKD,
    load_chuyen_kd_sai,
    getCameras,
    themKhachHang,
    getAllChamCongData,
    updateThongTinChuyenKD,
    huy_chuyen_kd,
    uploadExcelFileKD,
    getTongHopChuyen,
    getAllTrips,
    getDuLieuCoBan,
    getTiLeHoatDong,
    getTiLeLoiNhuanTheoXe,
    loadChiTietChuyenTheoXe,
    submitSuaChuaBaoDuong,
    Lay_DS_Taixe,  //Lấy danh sách tài xế trong user
    Lay_DS_Tram, //Lấy danh sách trạm bd-sc trong user
    Lay_DS_Bd_Sc,
    Lay_DS_Bd_Sc_tram,
    Ls_DS_Bd_Sc,
    Lay_CP_Bd_Sc,
    Update_Bd_Sc,
    UpdateTaiXe,
    getRouting,
    getCoordinatesFromAddress,
    TaoDonCongNo,
    themDonViKinhDoanh,
    getDonViKinhDoanh,
    getDanhSachCongNo,
    getLichSuThanhToanCongNo,
    thanhToanCongNo,
    capNhatLichSuThanhToan,
    CapNhatCongNo,
    Lay_DS_Sale,
    taoHopDong, //Tạo hợp đồng mới
    getMaHopDong, //Lấy danh sách mã hợp đồng
    ganMaHopDong,  //Gắn mã hợp đồng
    getThongTinXe,
    getDuLieuXe,
};

export default ManagerService;
